<template>
  <div
    v-expose-track="{
      [routerName]: {
        mapId: mapId,
        data: {
          spm: $trackMap[reportModle].goodExpose,
          ssu_id: ssu.ssuId,
          price: ssu.priceSpm || '',
          ...commonTracerParam,
          ...(ssu.extraTrack ? ssu.extraTrack : {})
        }
      }
    }"
    class="ssu-info"
    @click.stop="goDetail"
  >
    <price-tag v-if="priceTag" :tag="priceTag" :sub="priceSub"></price-tag>
    <div class="ssu-price">
      <div v-if="ssu.ssuPrice.priceShield" class="price-shield">
        {{ ssu.ssuPrice.priceShieldText }}
      </div>
      <good-price v-else :ssu="ssu"></good-price>
      <div class="operator-wrapper">
        <new-operator
          use-red-add-cart
          :use-icon="false"
          :btn-text="'加购物车'"
          :btn-width="customOperator.btnWith"
          :use-arrived-notice-icon="customOperator.simple"
          show-simple-count
          :computed-s-su="ssu"
          :show-can-not-buy="false"
          @add="addGoods"
          @subtract="subtractGoods"
          @goDetail="goDetail"
        />
      </div>
    </div>
    <ssu-deposit :show-deposit="showDeposit" :ssu="ssu"></ssu-deposit>
  </div>
</template>

<script>
import priceTag from '../priceTag'
import GoodPrice from '../goodPrice'
import SsuDeposit from '../ssuDeposit'
import NewOperator from '@/common/widgets/newOperator/newIndex.vue'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  components: {
    priceTag,
    GoodPrice,
    NewOperator,
    SsuDeposit
  },
  props: {
    ssu: {
      type: Object,
      default: () => {}
    },
    skuIndex: {
      type: Number,
      default: 0
    },
    showDeposit: {
      type: Boolean,
      default: false
    },
    reportModle: {
      type: String,
      default: ''
    },
    routerName: {
      type: String,
      default: ''
    },
    mapId: {
      type: String,
      default: ''
    },
    commonTracerParam: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      customOperator: {
        btnWith: '1.36',
        simple: false
      }
    }
  },
  computed: {
    priceTag() {
      const priceTag = this.ssu.ssuPrice?.priceUpperTag?.[0]?.tag || ''
      return priceTag
    },
    priceSub() {
      const suffixText = this.ssu.ssuPrice?.priceUpperTag?.[0]?.suffixText || ''
      return suffixText
    },
    depositInfo() {
      const depositInfo =
        this.ssu.ssuPrice.depositInfo || this.ssu.ssuPrice.packagePriceMsg || ''

      return depositInfo
    },
    ssuCommonTracerParams() {
      return Object.assign(
        {},
        {
          sku_id: this.skuId,
          sku_pos: this.skuIndex,
          ssu_id: this.ssu.ssuId,
          price: this.ssu.priceSpm
        },
        this.commonTracerParam,
        this.ssu.extraTrack ? this.ssu.extraTrack : {}
      )
    }
  },
  created() {},
  methods: {
    tracerReport(spm = '', params = {}) {
      this.$track(spm, Object.assign({}, this.ssuCommonTracerParams, params))
    },
    goDetailTrack(params) {
      if (this.reportModle) {
        const spm = this.$trackMap[this.reportModle].goodGoDetail
        if (spm) {
          this.tracerReport(spm, params)
        }
      }
    },
    addCartTrack(params) {
      if (this.reportModle) {
        const spm = this.$trackMap[this.reportModle].goodAdd
        if (spm) {
          this.tracerReport(spm, params)
        }
      }
    },
    minCartTrack(params) {
      if (this.reportModle) {
        const spm = this.$trackMap[this.reportModle].miniCart
        if (spm) {
          this.tracerReport(spm, params)
        }
      }
    },
    // 商品加购处理
    addGoods() {
      const params = this.ssuCommonTracerParams
      this.addCartTrack(params)
    },
    // 商品减购处理
    subtractGoods() {
      const params = this.ssuCommonTracerParams
      this.minCartTrack(params)
    },
    goDetail() {
      const params = this.ssuCommonTracerParams
      this.goDetailTrack(params)
      const ssu = this.ssu
      const spm = this.$trackMap[this.reportModle].goodGoDetail
      const tickReferId = `${spm}.${this.skuIndex}`
      this.$nativeRedirect(nativeRoutes.goodsDetail, {
        id: ssu.ssuId,
        tickReferId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ssu-price {
  display: flex;
  align-items: center;
  position: relative;
  .price-shield {
    font-size: 0.24rem;
    line-height: 0.32rem;
    color: #f03100;
  }
}
.operator-wrapper {
  position: relative;
  right: 0;
}
.ssu-deposit {
  color: #666666;
  font-size: 11px;
  letter-spacing: 0;
  margin-top: 8px;
}
</style>
